import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-zinc-200 bg-white px-6 py-4 mt-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-500 font-mono">
        <div>
          © {year} GrantFlow Inc. All rights reserved. Unauthorized duplication,
          scraping or redistribution of any AI-generated proposal content is prohibited.
        </div>
        <div className="flex items-center gap-4">
          <Link
            to="/legal/terms"
            data-testid="footer-link-terms"
            className="hover:text-zinc-900"
          >
            Terms
          </Link>
          <Link
            to="/legal/privacy"
            data-testid="footer-link-privacy"
            className="hover:text-zinc-900"
          >
            Privacy
          </Link>
          <Link
            to="/legal/copyright"
            data-testid="footer-link-copyright"
            className="hover:text-zinc-900"
          >
            Copyright
          </Link>
          <Link
            to="/help"
            data-testid="footer-link-help"
            className="hover:text-zinc-900"
          >
            Help
          </Link>
          <span>v1.2</span>
        </div>
      </div>
    </footer>
  );
}
